import React from 'react'
import { Button, Col, Divider, Row, Spin, Typography } from 'antd'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { FileExcelOutlined } from '@ant-design/icons'

import '../../asset/less/Pieces.less'
import { onPaginationSave } from '../../action/style'
import ArtworkPiecesPanel from '../../component/piece/ArtworkPiecesPanel'
import { URL_BULK_UPLOAD_UPDATE, URL_NEW_PIECES } from '../../const'
import AddPrimaryButton from '../../component/base/AddPrimaryButton'

const { Title } = Typography

@connect(
  (state) => ({
    id: state.user.info.id, // real user id, admin_id or artist_id
    userId: state.user.info.userId, // artist user obj id
    artistId: state.user.info.artistId, // artist obj id
    artistName: state.user.info.artistName,
    email: state.user.info.email,
    role: state.user.info.role
  }),
  {
    onPaginationSave
  }
)
class Pieces extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      rawData: []
    }
  }

  componentDidMount() {}

  onDataUpdate = (data) => {
    this.setState({
      rawData: data
    })
  }

  render() {
    return (
      <Spin size='large' spinning={this.state.loading}>
        <div className='site-layout-background'>
          <Row align='middle' gutter={{ xs: 8, sm: 16, md: 24 }}>
            <Col>
              <Title style={{ marginBottom: 0 }}>Sale Report</Title>
            </Col>
          </Row>
        </div>
      </Spin>
    )
  }
}

export default withRouter(Pieces)
